import { Network } from "../../../utils/network";
import { contestActionTypes } from "./contest.actionTypes";

export const getContestCoinsBalance =
  (contestId) => async (dispatch, state) => {
    try {
      if (contestId) {
        const res = await Network.getContestBalance(contestId);
        dispatch({
          type: contestActionTypes.SET_CONTEST_BALANCE_SUCCESS,
          payload: res?.data,
        });
      }
    } catch (e) {
      dispatch({
        type: contestActionTypes.SET_CONTEST_BALANCE_ERROR,
        payload: e?.response,
      });
    }
  };
export const getContestClose = (data) => {
  return async (dispatch, state) => {
    try {
      dispatch({
        type: contestActionTypes.CONTEST_CLOSED_LOADING,
      });
      const res = await Network.getContestClose();

      dispatch({
        type: contestActionTypes.CONTEST_CLOSED_SUCCESS,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: contestActionTypes.CONTEST_CLOSED_ERROR,
      });
    }
  };
};

export const setContestBalanceEmpty =
  (contestId) => async (dispatch, state) => {
    dispatch({
      type: contestActionTypes.SET_CONTEST_BALANCE_SUCCESS,
      payload: null,
    });
  };

export const getContestLive = (data) => {
  return async (dispatch, state) => {
    try {
      dispatch({
        type: contestActionTypes.CONTEST_LIVE_LOADING,
      });
      const res = await Network.getContestLive();

      dispatch({
        type: contestActionTypes.CONTEST_LIVE_SUCCESS,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: contestActionTypes.CONTEST_LIVE_ERROR,
      });
    }
  };
};

export const getContestEvents = (contestId, data) => {
  return async (dispatch, state) => {
    try {
      dispatch({
        type: contestActionTypes.CONTEST_EVENT_LOADING,
      });
      const res = await Network.contestEvents({ contest_id: +contestId });

      dispatch({
        type: contestActionTypes.CONTEST_EVENT_SUCCESS,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: contestActionTypes.CONTEST_EVENT_ERROR,
      });
    }
  };
};

export const setContestVisible = (contestId, data) => {
  return async (dispatch, state) => {
    dispatch({
      type: contestActionTypes.SET_CONTEST_VISIBLE,
      payload: true,
    });
  };
};

export const removeContest = (data, id) => async (dispatch, state) => {
  try {
    let tempData = [];
    let isExist = false;
    var removeByAttr = function (arr, attr, value) {
      var i = arr.length;
      while (i--) {
        if (
          arr[i] &&
          arr[i].hasOwnProperty(attr) &&
          arguments.length > 2 &&
          arr[i][attr] === value
        ) {
          isExist = true;
          arr.splice(i, 1);
          break;
        }
      }
      return arr;
    };
    tempData = removeByAttr(data?.contests, "id", id);
    if (isExist) {
      data.contests = tempData;
      dispatch({
        type: contestActionTypes.CONTEST_LIVE_SUCCESS,
        payload: { ...data },
      });
    }
  } catch (e) {
    dispatch({
      type: contestActionTypes.CONTEST_EVENT_ERROR,
    });
  }
};

export const removeContestProbe = (data, id) => async (dispatch, state) => {
  try {
    let tempData = [];
    let isExist = false;
    var removeByAttr = function (arr, attr, value) {
      var i = arr.length;
      while (i--) {
        if (
          arr[i] &&
          arr[i].hasOwnProperty(attr) &&
          arguments.length > 2 &&
          arr[i][attr] === value
        ) {
          isExist = true;
          arr.splice(i, 1);
          break;
        }
      }
      return arr;
    };
    tempData = removeByAttr(data?.probes, "id", id);
    if (isExist) {
      data.probes = tempData;
      dispatch({
        type: contestActionTypes.CONTEST_EVENT_SUCCESS,
        payload: { ...data },
      });
    }
  } catch (e) {
    dispatch({
      type: contestActionTypes.CONTEST_EVENT_ERROR,
    });
  }
};
